export const propertyLookupModes = {
  singleSelection: 0,
  multiSelection: 1,
};

export const ownerLookupModes = {
  singleSelection: 0,
  multiSelection: 1,
};

export const deedLookupModes = {
  singleSelection: 0,
  multiSelection: 1,
};

export const applicationLookupModes = {
  singleSelection: 0,
  multiSelection: 1,
};

export const AppraisalRoute = {
  AppraisalBuilderPlanCreate: '/appraisal/builderplans/create',
  AppraisalBuilderPlanDetail: '/appraisal/builderplans/:builderPlanId/detail',
  AppraisalBuilderPlansSearch: '/appraisal/builderplans/search',
  AppraisalDeedDetail: '/appraisal/deeds/:deedId/detail',
  AppraisalDeedsSearch: '/appraisal/deeds/search',
  AppraisalMobileHomeSearch: '/appraisal/mobilehome/search',
  AppraisalElectronicDeliveryRequestSearchTaxpayer:
    '/appraisal/electronicDeliveryRequestTaxpayer/search',
  AppraisalElectronicDeliveryRequestSearchAgent:
    '/appraisal/electronicDeliveryRequestAgent/search',
  AppraisalElectronicDeliveryRequestNewTaxpayer:
    '/appraisal/electronicDeliveryRequestNewTaxpayer',
  AppraisalElectronicDeliveryRequestDetailTaxpayer:
    '/appraisal/electronicDeliveryRequestTaxpayer/:requestID',
  AppraisalElectronicDeliveryRequestNewAgent:
    '/appraisal/electronicDeliveryRequestNewAgent',
  AppraisalElectronicDeliveryRequestDetailAgent:
    '/appraisal/electronicDeliveryRequestAgent/:requestID',
  AppraisalIncomingCalls: '/appraisal/incoming-calls',
  AppraisalEvaluation: '/appraisal/evaluation',
  AppraisalOwner: '/appraisal/ownerProperty',
  AppraisalOwnerSearch: '/appraisal/owner/search',
  AppraisalOwnerCreate: '/appraisal/owner/create',
  AppraisalOwnerDetail: '/appraisal/ownerRecord/:ownerId',
  AppraisalAgent: '/appraisal/agentProperty',
  AppraisalAgentSearch: '/appraisal/agent/search',
  AppraisalAgentCreate: '/appraisal/agent/create',
  AppraisalAgentMassEntryWalkthrough: '/appraisal/agent/massentry/walkthrough',
  AppraisalAgentDetail: '/appraisal/agentRecord/:agentId',
  AppraisalPropertyAgentDetail: '/appraisal/agentSummary/:pId/:agentId/detail',
  AppraisalPropertyAgentFiduciary:
    '/appraisal/agentSummary/:pId/:propertyAccountAgentID/fiduciary',
  AppraisalPropertyAgentBetaDetail:
    '/appraisal/agentSummaryBeta/:pId/:agentId/detail',
  AppraisalPropertyAgentBetaFiduciary:
    '/appraisal/agentSummaryBeta/:pId/:propertyAccountAgentID/fiduciary',

  AppraisalMortgagelender: '/appraisal/mortgagelenderProperty',
  AppraisalMortgagelenderSearch: '/appraisal/mortgagelender/search',
  AppraisalMortgagelenderCreate: '/appraisal/mortgagelender/create',
  AppraisalMortgagelenderDetail:
    '/appraisal/mortgagelenderRecord/:mortgagelenderId',
  AppraisalWebpageCreate: '/appraisal/webpage/create',
  AppraisalWebpageDetail: '/appraisal/webpage/edit/:webpageId',
  AppraisalPageLibrary: '/appraisal/webpages',
  AppraisalSubcomponentCreate: '/appraisal/subcomponent/create',
  AppraisalSubcomponentDetail: '/appraisal/subcomponent/edit/:subcomponentId',
  AppraisalSubcomponentLibrary: '/appraisal/subcomponents',
  AppraisalPropertySearch: '/appraisal/property/search',
  AppraisalPropertyEquitySearch: '/appraisal/equity-property/search',
  AppraisalPropertySmartGroupsSearch: '/appraisal/search/smartgroup/',
  AppraisalPropertySmartGroup: '/appraisal/smartgroup/:groupId',
  AppraisalPropertyPage:
    '/appraisal/property/:propertyId/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalPropertyMassCreate: '/appraisal/property/masscreate',
  AppraisalPropertyMerge: '/appraisal/property/merge',
  AppraisalPropertySplit:
    '/appraisal/property/split/:propertyId?/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalPropertyTransfer:
    '/appraisal/property/transfer/:propertyId?/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalTaxOfficeHistory:
    '/property/:propertyId/:year/:version/:rollCorr/tax-office-history',
  AppraisalMassCreateProperties:
    '/appraisal/property/create/:massCreateId/property-listing',
  AppraisalPropertyMassCreateWalkthrough:
    '/appraisal/property/masscreate/walkthrough',
  AppraisalPropertyCreateWalkthrough: '/appraisal/property/create/walkhtrough',
  AppealCreateWalkthrough: '/appraisal/appeal/create/walkthrough/:propertyId?',
  AppraisalPropertyEditWalkthrough:
    '/appraisal/property/create/walkthrough/:massCreateId',
  AppraisalRenditionWalkthrough:
    '/appraisal/property/rendition/walkthrough/:propertyId?/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalBPPRenditionWalkthrough:
    '/appraisal/bpp-rendition-walkthru/:propertyId?',
  AppraisalExemptionWalkthru:
    '/appraisal/property/exemption/walkthrough/:propertyId/:pYear/:pVersion/:pRollCorr/:applicationId?',
  AppraisalWalkthroughSettings: '/appraisal/walkthrough/settings',
  AppraisalMenuProfile: '/appraisal/menuprofiles',
  AppraisalMenuProfileCreate: '/appraisal/menuprofile/create',
  AppraisalMenuProfileDetail: '/appraisal/menuprofile/edit/:menuprofileId',
  AppraisalMenuProfileDefaults: '/appraisal/menuprofile/defaults',
  AppraisalMenuProfileDefaultAdd: '/appraisal/menuprofile/defaults/add',
  AppraisalMenuProfileDefaultEdit:
    '/appraisal/menuprofile/defaults/edit/:defaultId',
  AppraisalDemoDashboard: '/appraisal/dashboard',
  AppraisalDashboard: '/appraisal/dashboard',
  AppraisalDashboardQuery: '/appraisal/dashboard/query',
  AppraisalSaleSearch: '/appraisal/sale/search',
  AppraisalSaleDetail: '/appraisal/saleRecord/:saleID',
  AppraisalBuildingPermitsSearch: '/appraisal/buildingpermits/search',
  AppraisalMassRematchListing: '/appraisal/buildingpermits/rematch-logs',
  AppraisalBuildingPermits: '/appraisal/buildingpermits/:buildingPermitID',
  AppraisalEconomicUnitsSearch: '/appraisal/economicunits/search',
  AppraisalEconomicUnitDetail:
    '/appraisal/economicunits/:economicUnitId/:pYear/:pVersion/:pRollCorr/:menu',
  AppraisalEconomicUnitCreate: '/appraisal/economicunits/create',
  AppraisalPropertyMap:
    '/appraisal/property-map/:mapType/:propertyId/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalSalesSearchMap: '/appraisal/sale/gis',
  AppraisalPropertyGisMap:
    '/appraisal/property-map/gis/:propertyId/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalPropertyNearmapMap:
    '/appraisal/property-map/nearmap/:propertyId/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalPropertyGoogleMap:
    '/appraisal/property-map/google/:propertyId/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalPropertyBingMap:
    '/appraisal/property-map/azure/:propertyId/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalPropertyCiMap:
    '/appraisal/property-map/ci/:propertyId/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalPropertyPictMap:
    '/appraisal/property-map/pictometry/:propertyId/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalPropertyCycloMap:
    '/appraisal/property-map/cyclomedia/:propertyId/:pYear?/:pVersion?/:pRollCorr?',
  AppraisalSmartListDisplay: '/appraisal/smart-lists/:smartListId',
  AppraisalSmartLists: '/appraisal/smart-lists',
  AppraisalDetailPlatDocumentView:
    '/appraisal/plat-document-view/:propertyId/:pYear/:pVersion/:pRollCorr/:platId/:activeStep',
  AppraisalMassImportValuations: '/appraisal/mass-import-valuation',
  AppraisalAgentPropertyCount: '/appraisal/agentPropertyCount/:agentId',
};

export const AppraisalPageTitle = {
  [AppraisalRoute.AppraisalDemoDashboard]: 'Dashboard',
  [AppraisalRoute.AppraisalDeedsSearch]: 'Deeds',
  [AppraisalRoute.AppraisalEvaluation]: 'Evaluation',
  [AppraisalRoute.AppraisalOwner]: 'Owner',
  [AppraisalRoute.AppraisalOwnerSearch]: 'Owner',
  [AppraisalRoute.AppraisalOwnerCreate]: 'Owner',
  [AppraisalRoute.AppraisalOwnerDetail]: 'Owner',
  [AppraisalRoute.AppraisalAgent]: 'Owner',
  [AppraisalRoute.AppraisalAgentSearch]: 'Agent',
  [AppraisalRoute.AppraisalAgentCreate]: 'Agent',
  [AppraisalRoute.AppraisalAgentMassEntryWalkthrough]: 'Mass Entry of Agent',
  [AppraisalRoute.AppraisalAgentDetail]: 'Agent',
  [AppraisalRoute.AppraisalMortgagelender]: 'Lender',
  [AppraisalRoute.AppraisalMortgagelenderSearch]: 'Lender',
  [AppraisalRoute.AppraisalMortgagelenderCreate]: 'Lender',
  [AppraisalRoute.AppraisalMortgagelenderDetail]: 'Lender',
  [AppraisalRoute.AppraisalWebpageCreate]: 'Webpage',
  [AppraisalRoute.AppraisalWebpageDetail]: 'Webpage',
  [AppraisalRoute.AppraisalPageLibrary]: 'Webpages',
  [AppraisalRoute.AppraisalSubcomponentCreate]: 'Subcomponent',
  [AppraisalRoute.AppraisalSubcomponentDetail]: 'Subcomponent',
  [AppraisalRoute.AppraisalSubcomponentLibrary]: 'Subcomponent',
  [AppraisalRoute.AppraisalPropertySearch]: 'Property Search',
  [AppraisalRoute.AppraisalPropertyEquitySearch]: 'Property Equity Search',
  [AppraisalRoute.AppraisalPropertyPage]: 'Property',
  [AppraisalRoute.AppraisalPropertyCreateWalkthrough]: 'Create Property',
  [AppraisalRoute.AppraisalPropertyMassCreate]: 'Mass Create Property',
  [AppraisalRoute.AppraisalPropertyMassCreateWalkthrough]:
    'Mass Create Property',
  [AppraisalRoute.AppraisalPropertyMerge]: 'Property Merge',
  [AppraisalRoute.AppraisalPropertyTransfer]: 'Ownership Transfer',
  '/appraisal/property/transfer': 'Ownership Transfer',
  [AppraisalRoute.AppraisalPropertyMerge]: 'Property Merge',
  [AppraisalRoute.AppraisalMassCreateProperties]: 'Job Log Property Listing',
  [AppraisalRoute.AppraisalPropertyEditWalkthrough]: 'Property',
  [AppraisalRoute.AppraisalRenditionWalkthrough]: 'Rendition Walkthru',
  [AppraisalRoute.AppraisalExemptionWalkthru]: 'Exemption Walkthru',
  [AppraisalRoute.AppraisalMenuProfileDefaults]: 'Menu Defaults',
  [AppraisalRoute.AppraisalMenuProfileDefaultAdd]: 'Add Menu Default',
  [AppraisalRoute.AppraisalMenuProfileDefaultEdit]: 'Edit Menu Default',
  [AppraisalRoute.AppraisalCodefileMaintenance]: 'Codefile Maintenance',
  [AppraisalRoute.AppraisalSaleSearch]: 'Sale',
  [AppraisalRoute.AppraisalSaleDetail]: 'Sale',
  [AppraisalRoute.AppraisalBuildingPermitsSearch]: 'Building Permits Search',
  [AppraisalRoute.AppraisalBuildingPermits]: 'Building Permits',
  [AppraisalRoute.AppraisalSmartLists]: 'Smart List Launcher',
  [AppraisalRoute.AppraisalSmartListDisplay]: '',
  [AppraisalRoute.AppraisalPropertyGisMap]: 'GIS Map',
  [AppraisalRoute.AppraisalPropertyNearmapMap]: 'Nearmap',
  [AppraisalRoute.AppraisalPropertyGoogleMap]: 'Google Map',
  [AppraisalRoute.AppraisalPropertyBingMap]: 'Azure Map',
  [AppraisalRoute.AppraisalPropertyCiMap]: 'CI Default View',
  [AppraisalRoute.AppraisalPropertyPictMap]: 'Pictometry Map',
  [AppraisalRoute.AppraisalPropertyCycloMap]: 'Cyclomedia Map',
  [AppraisalRoute.AppraisalMassImportValuations]: 'Mass Import Valuations',
  [AppraisalRoute.AppraisalAgentPropertyCount]: 'Agent',
};

export const economicUnitsMenu = [
  { title: 'Summary', link: 'summary' },
  { title: 'Data Input', link: 'data-input' },
  { title: 'Comments', link: 'comments' },
  { title: 'Events', link: 'events' },
  { title: 'Attachments', link: 'attachments' },
  { title: 'Rent Roll', link: 'rent-roll' },
  { title: 'Valuation', link: 'valuation' },
  { title: 'Reconciliation', link: 'reconciliation' },
  { title: 'Allocation & Distribution', link: 'allocation-distribution' },
  { title: 'Revision History', link: 'revision-history' },
];
